import React from 'react';
import { connect } from 'react-redux';
import map from 'lodash/map';
import compact from 'lodash/compact';
import { fetchCommentsMPGTB, deleteCommentMPGTB } from '../../../../../actions/entities/mpgtb/users';
import swal from "sweetalert2";

class CommentsModerationWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: null,
        };
    }

    componentDidMount() {
        const onSuccess = (response) => {
            this.setState({ messages: response.messages });
        };
        this.props.dispatch(fetchCommentsMPGTB(onSuccess));
    }

    onDelete(commentId) {
        const onSuccess = (response) => {
            this.setState({ messages: compact(map(this.state.messages, m => m.id !== response.mpgtbMessageId && m)) });
        };
        swal({
            title: 'Are you sure ?',
            type: 'info',
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Yes',
            cancelButtonText:
                'No',
        }).then(() => {
            this.props.dispatch(deleteCommentMPGTB(commentId, onSuccess));
        }).catch(error => {
            console.log(error);
        })
    };

    render() {
        const { messages } = this.state;
        return (
            <div className="box">
                <div className="box-header with-border">
                    <h3 className="box-title pull-left">
                        <i className="fa fa-user-circle-o"/> Comments Moderation
                    </h3><br />
                </div>
                <div className="box-body">
                    <div style={{ overflow: 'auto', marginBottom: '1rem', maxHeight: '700px' }}>
                        <table className="table table-bordered no-margin">
                            <thead>
                                <tr>
                                    <th className="text-center">Id</th>
                                    <th className="text-center">Author</th>
                                    <th className="text-center">Disliked</th>
                                    <th className="text-center">Comment</th>
                                    <th className="text-center" />
                                </tr>
                            </thead>
                            <tbody>
                            {
                                map(messages, m => {
                                    return (
                                        <tr key={m.id}>
                                            <th className="text-center">{m.league.id.split('_')[2]}</th>
                                            <th className="text-center">{m.author.email}</th>
                                            <th className="text-center">{m.disliked}</th>
                                            <th className="text-center comment" onClick={() => this.setState({ [m.id]: !this.state[m.id] })}>
                                                {
                                                    !this.state[m.id] ? (
                                                        <p>
                                                            <span>{m.comment.slice(0, 20)}</span>
                                                            {
                                                                m.comment.slice(0, 20).length !== m.comment.length &&
                                                                <span>...</span>
                                                            }
                                                        </p>
                                                        ) : (
                                                            <p>{m.comment}</p>
                                                    )
                                                }
                                            </th>
                                            <th className="text-center">
                                                <button className="btn btn-danger" onClick={() => this.onDelete(m.id)}>
                                                    <i className="fa fa-times-circle" />
                                                </button>
                                            </th>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    dispatch => ({ dispatch })
)(CommentsModerationWidget);



// WEBPACK FOOTER //
// ./src/pages/Other/MPGTB/Widgets/CommentsModeration/index.js